import { DataQualityAssetType, DataQualityDetailProps, DataQualityType, localizeDataQualityTypeName } from '@tableau/data-catalog-client-components';
import { removeNulls } from '@tableau/data-structures';
import { ListItem } from '@tableau/widgets';

import { L10n } from '../../../ts/L10n/L10n';
import { dataQualityOwnerToTableauUser, IDataQualityIndicatorInfo } from '../../models/IDataQualityIndicatorInfo';
import { DATA_QUALITY_DIALOG_TYPE_TEST_ID } from '../../styles/DataQualityStyles';

export const CERTIFIED_INDICATOR_TYPE = 'CERTIFIED';

export function dataQualityTypeListItem(type: DataQualityType): ListItem {
  return {
    content: localizeDataQualityTypeName(type),
    value: dataQualityTypeToString(type),
    testId: DATA_QUALITY_DIALOG_TYPE_TEST_ID + '-' + dataQualityTypeToString(type).toLowerCase()
  };
}

/**
 * The data quality types that can be set by the user.
 * Some data quality warnings are applied automatically by the server;
 * such types are not included here.
 */
export const userEditableDataQualityTypes: DataQualityType[] = [
  DataQualityType.WARNING,
  DataQualityType.DEPRECATED,
  DataQualityType.STALE,
  DataQualityType.MAINTENANCE,
  DataQualityType.SENSITIVE_DATA,
  DataQualityType.CERTIFIED,
];

export function dataQualityTypeToString(type: DataQualityType): string {
  return DataQualityType[type];
}

export function stringToDataQualityType(type: string): DataQualityType {
  switch (type) {
    case DataQualityType[DataQualityType.WARNING]: return DataQualityType.WARNING;
    case DataQualityType[DataQualityType.DEPRECATED]: return DataQualityType.DEPRECATED;
    case DataQualityType[DataQualityType.STALE]: return DataQualityType.STALE;
    case DataQualityType[DataQualityType.MAINTENANCE]: return DataQualityType.MAINTENANCE;
    case DataQualityType[DataQualityType.SENSITIVE_DATA]: return DataQualityType.SENSITIVE_DATA;
    case DataQualityType[DataQualityType.EXTRACT_REFRESH_FAILURE]: return DataQualityType.EXTRACT_REFRESH_FAILURE;
    case DataQualityType[DataQualityType.FLOW_RUN_FAILURE]: return DataQualityType.FLOW_RUN_FAILURE;
    case DataQualityType[DataQualityType.CERTIFIED]: return DataQualityType.CERTIFIED;
  }
  return DataQualityType.WARNING;
}

export function dataQualityIndicatorInfosToProps(
  props: { assetUrl: string, assetName: string, assetType: DataQualityAssetType, onContentItem: boolean },
  dqis: ReadonlyArray<IDataQualityIndicatorInfo>
): ReadonlyArray<DataQualityDetailProps> {

  const mappedIndicators = dqis.map(dqi => dataQualityIndicatorInfoToProps(props, dqi));
  return removeNulls(mappedIndicators);
}

function dataQualityIndicatorInfoToProps(
  props: { assetUrl: string, assetName: string, assetType: DataQualityAssetType, onContentItem: boolean },
  info: IDataQualityIndicatorInfo
): DataQualityDetailProps {

  if (!info || !info.isActive) {
    return null;
  }

  return {
    assetType: props.assetType,
    author: dataQualityOwnerToTableauUser(info.owner),
    localizedDate: L10n.localizedDateTime(info.updatedAt),
    type: stringToDataQualityType(info.type),
    message: info.message,
    newTab: false,
    isSevere: info.isSevere,
    ...props
  };
}
